(()=>{
  const OPTION_VALUE='AUTO_UTILITARIA_FIAT_PANDA';
  const OPTION_LABEL='Auto utilitaria · Fiat Panda · 30 €/giorno · 7 giorni = 210 €';
  const HASHES=new Set(['#fiat-panda','#rent-private','#noleggio-utilitaria']);
  let panel=null;
  let lastTrigger=null;

  const track=source=>{
    if(typeof window.gtag==='function'){
      window.gtag('event','rent_private_open',{source,vehicle:'Fiat Panda',tariffa_giornaliera:30,minimo_giorni:7});
    }
  };

  const cleanHash=()=>{
    if(!HASHES.has(location.hash))return;
    const url=new URL(location.href);
    url.hash='';
    history.replaceState(history.state,'',`${url.pathname}${url.search}`);
  };

  function preparePanel(){
    const section=document.getElementById('rent-private');
    if(!section)return false;

    if(section.dataset.pandaV2Ready!=='true'){
      section.dataset.pandaV2Ready='true';
      const originalChildren=[...section.childNodes];

      const backdrop=document.createElement('div');
      backdrop.className='panda-v2-backdrop';
      backdrop.setAttribute('data-panda-v2-close','');

      const shell=document.createElement('div');
      shell.className='panda-v2-shell';
      shell.setAttribute('role','document');

      const topbar=document.createElement('div');
      topbar.className='panda-v2-topbar';
      topbar.innerHTML='<button class="panda-v2-back" type="button" data-panda-v2-close>← TORNA AI FURGONI</button><span>MASSA GOMME RENT PRIVATE · AUTO UTILITARIA FIAT PANDA</span><button class="panda-v2-close" type="button" data-panda-v2-close aria-label="Chiudi">×</button>';

      const page=document.createElement('div');
      page.className='panda-v2-page';
      originalChildren.forEach(node=>page.appendChild(node));

      shell.append(topbar,page);
      section.replaceChildren(backdrop,shell);
      section.classList.add('panda-v2-panel');
      section.hidden=true;
      section.setAttribute('role','dialog');
      section.setAttribute('aria-modal','true');
      section.setAttribute('aria-label','Noleggio auto utilitaria Fiat Panda');
      document.body.appendChild(section);

      const flow=section.querySelector('#private-rental-flow');
      const card=section.querySelector('#private-car-open');
      if(flow)flow.hidden=false;
      if(card){
        card.setAttribute('aria-expanded','true');
        card.tabIndex=-1;
      }

      section.querySelectorAll('[data-panda-v2-close]').forEach(button=>button.addEventListener('click',closePanda));
    }

    panel={
      section,
      flow:section.querySelector('#private-rental-flow'),
      back:section.querySelector('.panda-v2-back')
    };
    return true;
  }

  function openPanda(source='pulsante_fiat_panda'){
    lastTrigger=document.activeElement instanceof HTMLElement?document.activeElement:null;
    const started=Date.now();

    const attempt=()=>{
      if(preparePanel()){
        panel.section.hidden=false;
        if(panel.flow)panel.flow.hidden=false;
        document.body.classList.add('panda-v2-open');

        if(location.hash!=='#fiat-panda'){
          const url=new URL(location.href);
          url.hash='fiat-panda';
          history.pushState({panda:true},'',`${url.pathname}${url.search}${url.hash}`);
        }

        panel.back?.focus({preventScroll:true});
        track(source);
        return;
      }

      if(Date.now()-started<12000)setTimeout(attempt,100);
    };

    attempt();
  }

  function closePanda(){
    if(!panel?.section||panel.section.hidden)return;
    panel.section.hidden=true;
    document.body.classList.remove('panda-v2-open');
    cleanHash();
    if(lastTrigger&&document.contains(lastTrigger))lastTrigger.focus({preventScroll:true});
  }

  const bindStaticEntries=()=>{
    document.querySelectorAll('[data-panda-entry-v2]').forEach(entry=>{
      if(entry.dataset.pandaV2Bound==='true')return;
      entry.dataset.pandaV2Bound='true';
      entry.addEventListener('click',event=>{
        event.preventDefault();
        openPanda('pulsante_fisso_fiat_panda');
      });
    });
    return document.querySelector('[data-panda-entry-v2]')!==null;
  };

  const removeLegacyEntry=()=>{
    document.querySelectorAll('.navlinks a[href="#rent-private"],.navlinks a[href="#noleggio-utilitaria"]').forEach(link=>link.remove());
  };

  const ensureFilterEntry=()=>{
    const select=document.getElementById('vehicle-type-pref');
    if(!select)return false;

    let option=select.querySelector('option[data-panda-v2-option]');
    if(!option){
      option=document.createElement('option');
      option.setAttribute('data-panda-v2-option','true');
      option.value=OPTION_VALUE;
    }
    option.value=OPTION_VALUE;
    option.textContent=OPTION_LABEL;

    const grande=select.querySelector('option[value="Grande fino a ~3,70 m"]');
    const centinato=select.querySelector('option[value="Centinato ~4,10 m"]');
    if(grande&&grande.nextElementSibling!==option){
      grande.insertAdjacentElement('afterend',option);
    }else if(!grande&&!option.isConnected){
      select.insertBefore(option,centinato||null);
    }

    const label=document.querySelector('label[for="vehicle-type-pref"],.vehicle-pref-label');
    if(label&&label.textContent!=='Filtro dimensione / Auto utilitaria Fiat Panda'){
      label.textContent='Filtro dimensione / Auto utilitaria Fiat Panda';
    }

    if(select.dataset.pandaV2FilterBound!=='true'){
      select.dataset.pandaV2FilterBound='true';
      select.addEventListener('change',event=>{
        if(select.value!==OPTION_VALUE)return;
        event.preventDefault();
        event.stopImmediatePropagation();
        select.value='';
        openPanda('filtro_dimensioni_fiat_panda');
      },true);
    }

    return true;
  };

  const ensureAll=()=>{
    removeLegacyEntry();
    const buttonReady=bindStaticEntries();
    const filterReady=ensureFilterEntry();
    const panelReady=preparePanel();
    return buttonReady&&filterReady&&panelReady;
  };

  const start=()=>{
    window.MASSAGOMME_OPEN_RENT_PRIVATE=openPanda;
    let stableRuns=0;
    let totalRuns=0;
    let timer=null;

    const check=()=>{
      const ready=ensureAll();
      stableRuns=ready?stableRuns+1:0;
      totalRuns+=1;
      if((stableRuns>=8||totalRuns>=150)&&timer){
        clearInterval(timer);
        timer=null;
      }
    };

    check();
    timer=setInterval(check,100);

    if(HASHES.has(location.hash))openPanda('link_diretto_fiat_panda');
  };

  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'&&panel?.section&&!panel.section.hidden)closePanda();
  });

  window.addEventListener('hashchange',()=>{
    if(HASHES.has(location.hash))openPanda('link_diretto_fiat_panda');
    else if(panel?.section&&!panel.section.hidden){
      panel.section.hidden=true;
      document.body.classList.remove('panda-v2-open');
    }
  });

  window.addEventListener('pageshow',()=>{
    bindStaticEntries();
    ensureFilterEntry();
  });

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);
  else start();
})();
